/**
 * Think panel docking (approved host plate).
 *
 * collapsed 48px rail; ≥1440 expanded 384, draggable 320–480;
 * 1280–1439 = 320; <1280 existing Sheet. Main column stays ≥720.
 * Push content — never overlay the page.
 */

export const THINK_DOCK = {
  collapsed: 48,
  compact: 320,
  expandedDefault: 384,
  min: 320,
  max: 480,
  mainMin: 720,
  sheetBelow: 1280,
  dragAt: 1440,
} as const;

export function clampThinkWidth(desired: number, viewport: number): number {
  const room = viewport - THINK_DOCK.mainMin;
  const max = Math.min(THINK_DOCK.max, Math.max(THINK_DOCK.min, room));
  if (!Number.isFinite(desired)) return Math.min(max, THINK_DOCK.expandedDefault);
  return Math.min(max, Math.max(THINK_DOCK.min, desired));
}

export function thinkOpenWidth(viewport: number): number {
  if (viewport >= THINK_DOCK.dragAt) return THINK_DOCK.expandedDefault;
  return THINK_DOCK.compact;
}

export function thinkUsesSheet(viewport: number): boolean {
  return viewport < THINK_DOCK.sheetBelow;
}

/** Overlay / Sheet only when Think is requested AND the viewport is below 1280. */
export function thinkSheetOverlayOpen(viewport: number, thinkRequested: boolean): boolean {
  return thinkRequested && thinkUsesSheet(viewport);
}

export function thinkWidthAfterArrow(
  current: number,
  key: "ArrowLeft" | "ArrowRight" | "ArrowUp" | "ArrowDown",
  viewport: number,
): number {
  const grow = key === "ArrowLeft" || key === "ArrowUp";
  return clampThinkWidth(current + (grow ? 16 : -16), viewport);
}

export function readThinkWidthPx(raw: string | null | undefined, fallback: number = THINK_DOCK.compact): number {
  if (!raw) return fallback;
  const n = Number.parseFloat(raw);
  return Number.isFinite(n) ? n : fallback;
}
